<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "Thống kê điểm danh",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {},
  data() {
    return {
      title: "Thống kê điểm danh",
      items: [
        {
          text: "Danh sách",
          href: "/vai-tro",
          active: true,
        },
      ],
    };
  },
  validations: {},
  created() {
  },
}
</script>
<template>
  <div>
    <div class="row ">
      <div class="col-12">
        <div class="card">
          <div class="card-body iframe-container">
            <iframe
                src="https://attendo.dthu.edu.vn/dashboard/school-leader"
                width="100%"
                frameborder="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
